const GROUPS = {
    MAIN: "ZGPPAL"
}

export default {GROUPS}
